import React from 'react';
import { Mail, Phone, MapPin, Printer } from 'lucide-react';
import Footer from '../components/Footer';

const Contact = () => {
  const contacts = [
    {
      name: "Ms. Keyla Llorente",
      title: "Site Coordinator",
      location: "1434 Ogden Ave.",
      email: "kllorente@schools.nyc.gov"
    },
    {
      name: "Ms. Pamela Rossi",
      title: "Assistant Principal",
      location: "4179 Third Ave.",
      email: "prossi2@schools.nyc.gov"
    },
    {
      name: "Ms. Marytery Caceres",
      title: "Social Studies (Cluster)",
      location: "4179 Third Ave.",
      email: "mcaceres4@schools.nyc.gov"
    },
    {
      name: "Ms. Emily Rojas",
      title: "Secretary",
      location: "4179 Third Ave.",
      email: "erosjas@schools.nyc.gov"
    },
    {
      name: "Ms. Dannia Velasquez",
      title: "Secretary",
      location: "1434 Ogden Ave. & 1302 Edward L. Grant Hwy",
      email: "dvelasquez2@schools.nyc.gov"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <header className="text-center mb-16">
          <span className="text-[#7d5800] font-bold text-sm uppercase tracking-wider">Get In Touch</span>
          <h1 className="text-5xl md:text-6xl font-bold text-[#123f1e] mt-4">
            Contact Us
          </h1>
        </header>

        {/* Welcome Image */}
        <div className="mb-16">
          <img
            src="/assets/images/gallery/District9PreK-189.jpg"
            alt="Garden of Learning staff team"
            className="w-full max-w-5xl mx-auto h-80 object-cover rounded-3xl shadow-xl"
          />
        </div>

        {/* Contact Information */}
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {/* Location Cards */}
          <div className="space-y-6">
            <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-[#febc04] transition-all">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-[#123f1e] rounded-xl">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1">
                  <h2 className="text-xl font-bold text-[#123f1e] mb-2">4179 Third Ave.</h2>
                  <p className="text-gray-600 mb-4">Bronx, NY 10457</p>
                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-[#123f1e]">
                      <Phone className="w-4 h-4" />
                      <a href="tel:929-688-4547" className="hover:text-[#7d5800] transition-colors">
                        (929) 688-4547 Ext. 1082
                      </a>
                    </div>
                    <div className="flex items-center gap-2 text-gray-600">
                      <Printer className="w-4 h-4" />
                      <span className="text-sm">Fax: (929) 688-4532</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-[#febc04] transition-all">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-[#febc04] rounded-xl">
                  <MapPin className="w-6 h-6 text-[#123f1e]" />
                </div>
                <div className="flex-1">
                  <h2 className="text-xl font-bold text-[#123f1e] mb-2">1434 Ogden Ave.</h2>
                  <p className="text-gray-600 mb-4">Bronx, NY 10452</p>
                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-[#123f1e]">
                      <Phone className="w-4 h-4" />
                      <a href="tel:718-583-8975" className="hover:text-[#7d5800] transition-colors">
                        (718) 583-8975 Ext. 1151
                      </a>
                    </div>
                    <div className="flex items-center gap-2 text-gray-600">
                      <Printer className="w-4 h-4" />
                      <span className="text-sm">Fax: (718) 583-8987</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-[#febc04] transition-all">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-[#123f1e] rounded-xl">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1">
                  <h2 className="text-xl font-bold text-[#123f1e] mb-2">1302 Edward L. Grant Hwy</h2>
                  <p className="text-gray-600 mb-1">(Aurelia Greene Campus)</p>
                  <p className="text-gray-600 mb-4">Bronx, NY 10452</p>
                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-[#123f1e]">
                      <Phone className="w-4 h-4" />
                      <a href="tel:646-298-1850" className="hover:text-[#7d5800] transition-colors">
                        (646) 298-1850 Ext. 1084
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-[#123f1e] rounded-3xl p-8 text-white">
            <h2 className="text-2xl font-bold mb-6">Send Us a Message</h2>
            <form className="space-y-4">
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium mb-2">Name</label>
                <input
                  id="contact-name"
                  type="text"
                  required
                  className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-[#febc04]"
                  placeholder="Your name"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium mb-2">Email</label>
                <input
                  id="contact-email"
                  type="email"
                  required
                  className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-[#febc04]"
                  placeholder="your.email@example.com"
                />
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-sm font-medium mb-2">Message</label>
                <textarea
                  id="contact-message"
                  rows="4"
                  required
                  className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-[#febc04]"
                  placeholder="Your message..."
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full px-6 py-4 bg-[#febc04] text-[#123f1e] font-bold rounded-xl hover:bg-[#e5a903] transition-all"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>

        {/* Staff Contacts */}
        <div>
          <h2 className="text-3xl font-bold text-[#123f1e] mb-8 text-center">Key Staff Contacts</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {contacts.map((contact, index) => (
              <div key={index} className="bg-white border-2 border-gray-200 rounded-2xl p-6 hover:border-[#febc04] transition-all">
                <h3 className="text-lg font-bold text-[#123f1e] mb-2">{contact.name}</h3>
                <p className="text-sm text-gray-600 mb-1">{contact.title}</p>
                <p className="text-xs text-gray-500 mb-3">{contact.location}</p>
                <a
                  href={`mailto:${contact.email}`}
                  className="inline-flex items-center gap-2 text-sm text-[#123f1e] hover:text-[#7d5800] transition-colors break-all"
                >
                  <Mail className="w-4 h-4 flex-shrink-0" />
                  <span>{contact.email}</span>
                </a>
              </div>
            ))}
          </div>
        </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
